"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledToggleCard = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Card = require("../Card/Card");
var StyledToggleCard = /*#__PURE__*/(0, _styledComponents.default)(_Card.Card).withConfig({
  displayName: "StyledToggleCard",
  componentId: "c11n-8-107-0__sc-1qv1mi1-0"
})([""]);
exports.StyledToggleCard = StyledToggleCard;